import { render, staticRenderFns } from "./ed-presentation-mode-guest-teacher.component.vue?vue&type=template&id=e4c0cf86&scoped=true&"
import script from "./ed-presentation-mode-guest-teacher.component?vue&type=script&lang=ts&"
export * from "./ed-presentation-mode-guest-teacher.component?vue&type=script&lang=ts&"
import style0 from "./ed-presentation-mode-guest-teacher.component.scss?vue&type=style&index=0&id=e4c0cf86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4c0cf86",
  null
  
)

export default component.exports